'use client';
import cn from 'classnames';
import styles from './Modal.module.scss';
import { ReactNode, useRef } from 'react';
import { Backdrop } from '../Backdrop';
import { createPortal } from 'react-dom';

type ModalProps = {
  showCloseButton?: boolean;
  className?: string;
  children: ReactNode;
  active: boolean;
  onClose: () => void;
  contentClass?: string;
};

export function Modal({
  showCloseButton,
  active,
  onClose,
  children,
  className,
  contentClass,
}: ModalProps) {
  const wrapperClassName = cn(styles.wrapper, className);
  const contentClassName = cn(styles.content, contentClass);
  const modalRef = useRef<HTMLDivElement>(null);

  if (!active) return null;

  return createPortal(
    <div className={wrapperClassName} ref={modalRef}>
      <Backdrop visible={active} onClick={onClose} />
      <div className={contentClassName}>
        {children}
        {showCloseButton && (
          <img
            src="/svg/close-gray.svg"
            alt="close"
            className={styles.close}
            onClick={onClose}
          />
        )}
      </div>
    </div>,
    document.body,
  );
}
